import React, { useEffect, useState } from "react";
import DemoInterestedSection from "../../Component/DemoInterestedSection";
import FAQsBannerSection from "./component/FAQsBannerSection";
import MainFaqsSection from "./component/MainFaqsSection";

function FAQsPage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch(
        "https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/faq"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    onRefresh();
  }, []);

  return (
    <>
      <FAQsBannerSection faq_banner={acfData?.faq_banner} />
      <MainFaqsSection acfData={acfData?.faqs ?? []} />
      <DemoInterestedSection acfData={acfData} />
    </>
  );
}

export default FAQsPage;
